<div class="container-right-main fluid-container">
    <div class="display-flex">
        <div class="float-left">
            <h2>Roleplay Feedback</h2>
        </div>
        <div id="rp-feedback-loader" class="loader" style="display:none;"></div>
    </div>

    <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
        <mat-tab label="All Feedback" *ngIf="canViewAllFeedbackTab">
            <div class="display-flex filter-container">
                <div class="float-left">
                    <app-search-field [formControl]="searchFilter"
                        placeholder="Search by session objective and submitted by..." [showMatchCount]="true"
                        [matchCount]="totalCount">
                    </app-search-field>
                </div>
            </div>

            <app-grid [data]="filteredList" [columns]="columns" [config]="gridConfig" (rowClick)="onRowClick($event)">
            </app-grid>

            <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="currentPage"
                [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)" showFirstLastButtons>
            </mat-paginator>
        </mat-tab>

        <mat-tab label="Assigned Feedback" *ngIf="canViewAssignedFeedbackTab">
            <div class="display-flex filter-container">
                <div class="float-left">
                    <app-search-field [formControl]="searchFilter"
                        placeholder="Search by session objective and submitted by..." [showMatchCount]="true"
                        [matchCount]="totalCount">
                    </app-search-field>
                </div>
            </div>

            <app-grid [data]="filteredList" [columns]="columns" [config]="gridConfig" (rowClick)="onRowClick($event)">
            </app-grid>

            <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="currentPage"
                [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)" showFirstLastButtons>
            </mat-paginator>
        </mat-tab>
    </mat-tab-group>
</div>